module.exports = __webpack_public_path__ + "media/images/rename-icon-c04accc920a9ee8eb5460cdb9f839303.svg";